import React from 'react';
import Text from '../../../components/Text';
import Button from '../../../components/Button';

interface DeleteColorModalProps {
    colorId: number;
    colorName: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteColorModal: React.FC<DeleteColorModalProps> = ({ colorName, onConfirm, onCancel }) => {
    return (
        <div>
            <Text classes={'zr-mb-4'}>{`Farbe "${colorName}" wirklich löschen?`}</Text>
            <div className={'zr-d-flex zr-gap-2'}>
                <Button
                    hierarchy="primary"
                    text="Löschen"
                    fn={onConfirm}
                />
                <Button
                    hierarchy="secondary"
                    text="Abbrechen"
                    fn={onCancel}
                />
            </div>
        </div>
    );
};
